














import Vue from 'vue'
import {
  ProductInfo,
  ProductState
} from '@/product/types'
export default Vue.extend({
  computed: {
    product(): ProductInfo {
      return (this.$store.state as ProductState).productDetail.product
    }
  }
})
